import React from 'react';
import { Trans } from 'react-i18next';
import type { TFunction } from 'i18next';
import { CredentialsStepLabels } from './CredentialsStep';

export const buildCredentialsLabels = (
  t: TFunction,
  baseKey: string,
  { withSectionTitle = false }: { withSectionTitle?: boolean } = {}
): CredentialsStepLabels => {
  const CREDENTIALS = `${baseKey}.credentialsStep`;
  const CRED_ERRORS = `${CREDENTIALS}.errors`;

  return {
    ...(withSectionTitle
      ? { sectionTitle: t(`${CREDENTIALS}.SECTION_TITLE`) }
      : {}),
    parentUuidLabel: t(`${CREDENTIALS}.PARENT_UUID_LABEL`),
    parentUuidPlaceholder: t(`${CREDENTIALS}.PARENT_UUID_PLACEHOLDER`),
    parentUuidError: t(`${CRED_ERRORS}.INVALID_UUID`),
    parentUuidHint: t(`${CREDENTIALS}.PARENT_UUID_HINT`),
    uuidConfirmationCheckbox: t(`${CREDENTIALS}.UUID_CONFIRMATION_CHECKBOX`),
    fields: {
      apiKeyInfoBody: (
        <span>
          <Trans
            i18nKey={`activity:${CREDENTIALS}.API_KEY_INFO_BODY`}
            components={{ strong: <strong /> }}
          />
        </span>
      ),
      clientIdLabel: t(`${CREDENTIALS}.CLIENT_ID_LABEL`),
      clientIdPlaceholder: t(`${CREDENTIALS}.CLIENT_ID_PLACEHOLDER`),
      secretKeyLabel: t(`${CREDENTIALS}.SECRET_KEY_LABEL`),
      secretKeyPlaceholder: t(`${CREDENTIALS}.SECRET_KEY_PLACEHOLDER`),
      showSecretKey: t(`${CREDENTIALS}.SHOW_SECRET_KEY`),
      hideSecretKey: t(`${CREDENTIALS}.HIDE_SECRET_KEY`),
      adminEmailInfoBody: (
        <span>
          <Trans
            i18nKey={`activity:${CREDENTIALS}.ADMIN_EMAIL_INFO_BODY`}
            components={{ strong: <strong /> }}
          />
        </span>
      ),
      adminEmailLabel: t(`${CREDENTIALS}.ADMIN_EMAIL_LABEL`),
      adminEmailPlaceholder: t(`${CREDENTIALS}.ADMIN_EMAIL_PLACEHOLDER`),
      errors: {
        required: t(`${CRED_ERRORS}.REQUIRED`),
        invalidEmail: t(`${CRED_ERRORS}.INVALID_EMAIL`)
      }
    }
  };
};
